
import { defineComponent, PropType } from 'vue'

import { formatDate, parseISODate } from '~/utils/date'
import { getDefaultAvatar } from '~/utils/ui'

/**
 * Log entry component to display a log event
 */
export default defineComponent({
  name: 'Log',
  props: {
    actor: {
      type: Object as PropType<Record<string, string>>,
      required: false,
      default: null
    },
    description: {
      type: String,
      required: true
    },
    createdAt: {
      type: String,
      required: true
    }
  },
  methods: {
    getDefaultAvatar
  },
  computed: {
    absoluteDate(): string {
      return formatDate(this.parsedISODate)
    },
    absoluteDateWithTime(): string {
      return formatDate(this.parsedISODate, 'lll')
    },
    actorName(): string {
      if (this.actor?.fullName) {
        return this.actor.fullName
      }
      if (this.actor?.firstName) {
        return this.actor.firstName
      }
      if (this.actor?.email) {
        return this.actor.email
      }
      return ''
    },
    eventDescription(): string {
      if (this.description.endsWith('.')) {
        return this.description.substring(0, this.description.length - 1)
      }

      return this.description
    },
    parsedISODate(): Date {
      return parseISODate(this.createdAt)
    }
  }
})
